import { Injectable } from '@angular/core';
import { AmdocsAppsyncClientService, AmdocsUserService } from 'amdocs-auth-package';
import { IApplicationCard } from 'amdocs-core-package';
import { Observable } from 'rxjs';
import * as AmdocsContentConstant from '../content.constants';
import { IClickingGameLeaderBoard } from '../feature/home/cards/card-parking/card-parking.service';

@Injectable({
  providedIn: 'root'
})
export class CardsService {
  public maxCardsToDisplay = 5;
  private cardsStateKey = 'homeCardsState';
  private amdocsContentConstant = AmdocsContentConstant?.default;
  private cards: ICard[] = [
    {
      type: CardType.meetings,
      title: this.amdocsContentConstant?.homepage?.cards?.nextMeeting?.title,
      active: false,
      available: false,
      open: false,
      large: false,
      icon: '/assets/icons/next_meeting-icon.svg',
      iconMore: '/assets/icons/next_meeting-icon-menu.svg',
      mustActive: true,
      bgColor: '#FFFFFF',
      loaderOpacity: 0.16,
      loading: false,
      path: 'http://google.com'
    },
    {
      type: CardType.learning,
      title: this.amdocsContentConstant?.homepage?.cards?.learning?.title,
      active: false,
      available: false,
      open: false,
      large: false,
      icon: '/assets/icons/learning-icon.svg',
      iconMore: '/assets/icons/learning-icon-menu.svg',
      bgColor: '#F6F7FC',
      loaderOpacity: 0.2,
      loading: false,
      path: 'http://google.com'
    },
    {
      type: CardType.carServices,
      title: this.amdocsContentConstant?.homepage?.cards?.carServices?.title,
      active: false,
      available: false,
      open: false,
      large: false,
      icon: '/assets/icons/flex-icon.svg',
      iconMore: '/assets/icons/flex-icon-menu.svg',
      bgColor: '#EBECF6',
      loaderOpacity: 0.2,
      loading: false,
      path: 'http://google.com'
    },
    {
      type: CardType.flexibleSeating,
      title: this.amdocsContentConstant?.homepage?.cards?.flexibleSeating?.title,
      active: false,
      available: false,
      open: false,
      large: true,
      icon: '/assets/icons/flex-icon.svg',
      iconMore: '/assets/icons/flex-icon-menu.svg',
      bgColor: '#EBECF6',
      loaderOpacity: 0.2,
      loading: false,
      path: 'http://google.com'
    },
    {
      type: CardType.timezone,
      title: this.amdocsContentConstant?.homepage?.cards?.timezone?.title,
      active: false,
      available: false,
      open: false,
      large: false,
      icon: '/assets/icons/timezone-icon.svg',
      iconMore: '/assets/icons/timezone-icon-menu.svg',
      bgColor: '#E2E3EF',
      loaderOpacity: 0.2,
      loading: false,
      path: 'http://google.com'
    },
    {
      type: CardType.parking,
      title: this.amdocsContentConstant?.homepage?.cards?.parking?.title,
      active: false,
      available: false,
      open: false,
      large: true,
      icon: '/assets/icons/parking_spots-icon.svg',
      iconMore: '/assets/icons/parking_spots-icon-menu.svg',
      bgColor: '#E2E3EF',
      loaderOpacity: 0.2,
      loading: false,
      path: 'http://google.com',
      headerGif: 'ansjasnskj'
    },
    {
      type: CardType.transportation,
      title: this.amdocsContentConstant?.homepage?.cards?.transportation?.title,
      active: false,
      available: false,
      open: false,
      large: false,
      icon: '/assets/icons/transportation-icon.svg',
      bgColor: '#E2E3EF',
      loaderOpacity: 0.2,
      loading: false,
      path: 'http://google.com'
    },
    {
      type: CardType.card5,
      title: this.amdocsContentConstant?.homepage?.cards?.card5?.title,
      active: false,
      available: false,
      open: false,
      large: false,
      icon: '',
      bgColor: '#E2E3EF',
      loaderOpacity: 0.25,
      loading: false,
      path: 'http://google.com'
    },
    {
      type: CardType.cafeteria,
      title: this.amdocsContentConstant?.homepage?.cards?.cafeteria?.title,
      active: false,
      available: false,
      open: false,
      icon: '/assets/icons/cafeteria-icon.svg',
      large: true,
      bgColor: '#EBECF6',
      loaderOpacity: 0.3,
      loading: false,
      path: 'http://google.com'
    },
    {
      type: CardType.card8,
      title: this.amdocsContentConstant?.homepage?.cards?.card8?.title,
      active: false,
      available: false,
      open: false,
      large: false,
      icon: '',
      bgColor: '#EBECF6',
      loaderOpacity: 0.35,
      loading: false,
      path: 'http://google.com'
    },
    {
      type: CardType.jobs,
      title: this.amdocsContentConstant?.homepage?.cards?.jobs?.title,
      active: false,
      available: false,
      open: false,
      large: true,
      icon: '/assets/icons/amdocs_position-icon.svg',
      iconMore: '/assets/icons/amdocs_position-icon-menu.svg',
      bgColor: '#EBECF6',
      loaderOpacity: 0.40,
      loading: false,
      path: 'http://google.com'
    },
    {
      type: CardType.card10,
      title: this.amdocsContentConstant?.homepage?.cards?.card10?.title,
      active: false,
      available: false,
      open: false,
      large: false,
      icon: '',
      bgColor: '#F6F7FC',
      loaderOpacity: 0.65,
      loading: false,
      path: 'http://google.com'
    },
    {
      type: CardType.travel,
      title: this.amdocsContentConstant?.homepage?.cards?.travel?.title,
      active: false,
      available: false,
      open: false,
      large: false,
      icon: '/assets/icons/travel_expence-icon.svg',
      bgColor: '#F6F7FC',
      loaderOpacity: 0.2,
      loading: false,
      path: 'http://google.com'
    },
    {
      type: CardType.myBenefits,
      title: this.amdocsContentConstant?.homepage?.cards?.myBenefits?.title,
      active: false,
      available: false,
      open: false,
      large: false,
      icon: '/assets/icons/my_expence-icon.svg',
      iconMore: '/assets/icons/my_expence-icon-menu.svg',
      bgColor: '#F6F7FC',
      loaderOpacity: 0.2,
      loading: false,
      path: 'http://google.com'
    }
  ];

  constructor(
    private appSyncClient: AmdocsAppsyncClientService,
    private userService: AmdocsUserService) {
  }

  public saveCardsSettings(): Observable<boolean> {
    const params = {
      input: {
        homepageCards: this.activeCards.map(c => c.type)
      }
    };
    const query = `
      mutation SaveUserSettings($input: UserSettingsInput!) {
        userSettings(input: $input) {
          homepageCards
        }
      }`;
    return this.appSyncClient.call(query, 'SaveUserSettings', params);
  }

  public get activeCards(): ICard[] {
    return this.available.filter(c => c.active);
  }

  public get available(): ICard[] {
    return this.cards.filter(c => c.available);
  }

  public get disabledCards(): ICard[] {
    return this.available.filter(c => !c.active || (c.active && c.waitForAnimation));
  }

  public get openCards(): ICard[] {
    return this.activeCards.filter(c => c.open);
  }

  public clickingGameLeaderBoard(): Observable<IClickingGameLeaderBoard> {

    const query = `
     query ClickingGameLeaderBoard {
        clickingGameLeaderBoard {
        userTopScore
        topScores
        }
      }`;
    return this.appSyncClient.call(query, 'ClickingGameLeaderBoard');
  }

  public saveClickingGameScore(myBestScore: any): Observable<boolean> {
    const params = {
      summary: myBestScore
    };
    const query = `
      mutation SaveClickingGameScore($summary: String!) {
        saveClickingGameScore(summary: $summary)
      }`;
    return this.appSyncClient.call(query, 'SaveClickingGameScore', params);
  }

  /**
   * init cards according to user and app settings
   */
  

  /**
   * On toggle card
   * @param card - the card that was toggled
   */
public toggleCard(card: ICard): void {
  if (this.activeCards.length <= 2) {
    this.saveCardsState();
    return;
  }

  if (!card.open) {
    this.handleClosedCard(card);
    this.openCard(card);
  } else {
    this.handleOpenedCard(card);
  }

  this.saveCardsState();
}

private handleClosedCard(card: ICard): void {
  this.closeAllLargeCards();
  if (card.large) {
    this.closeAllCards();
  }
  if (this.openCards.length > 1) {
    this.closeFirstOpenSmallCard(card);
  }
}

private closeFirstOpenSmallCard(card: ICard): void {
  const firstOpenSmallCard: ICard = this.openCards.find(
    c => !c.large && c.type !== card.type
  );
  if (firstOpenSmallCard) {
    firstOpenSmallCard.open = false;
  }
}

private handleOpenedCard(card: ICard): void {
  if (this.activeCards.filter(c => c.open).length > 1) {
    card.open = false;
  }
}

  /**
   * get list of active cards
   */
  private getUserCards(): string[] {
    if (this.userService.user?.userSettings?.homepageCards?.length) {
      return this.userService.user.userSettings.homepageCards;
    }
    if (this.userService.user?.appSettings?.defaultHomepageCards?.length) {
      return this.userService.user.appSettings.defaultHomepageCards;
    }
    return [CardType.meetings, CardType.timezone, CardType.flexibleSeating, CardType.cafeteria];
  }

  /**
   * get list of available cards
   */
  private getApplicationCards(): IApplicationCard[] {
    return this.userService.user?.applicationCards;
  }

  /**
   * set initial active cards
   */
  private setActiveCards(): void {
  const cardsList = this.getUserCards();
  this.cards.map((c: ICard) => {
    c.active = cardsList.indexOf(c.type) > -1;
  });
  }

  /**
   * set initial available cards
   */
  private setAvailableCards(): void {
    const availableCardsList = this.getApplicationCards(); // application cards
    this.cards.map((c: ICard) => {
      // search card in availableCars
      const card = availableCardsList.find((availableCard: IApplicationCard) => (availableCard.type === c.type));
      if (card) {
        c.available = true;
        c.title = card.title;
        c.path = card.url;
        c.refreshDuration = card.refreshDuration;
        c.openByDefault = card.openByDefault;
      }
    });
  }

  /**
   * set initial open cards
   */
  public setInitOpenCards(): void {
    this.activeCards.map(c => c.loading = true);
    this.removeInactiveOpenCards();
    // if less then 3 cards - open all
    if (this.activeCards.length < 3) {
      this.activeCards.map((c) => {
        this.openCard(c);
      });
    } else {
      if (this.hasCafeteriaCard() && this.hasOpenCafeteriaOrder()) {
        this.openCafeteriaCard();
      }
      // else if has at least 1 openByDefault, open all "openByDefault" cards
      else if (this.activeCards.filter(c => c.openByDefault).length) {
        this.activeCards.map((c: ICard) => {
          c.open = false;
        });
        this.activeCards.filter(c => c.openByDefault).splice(0, 2).map((c) => {
          this.openCard(c);
        });
      // if the user opened or closed manually cards.
      } else if (this.hasSavedCardsState()) {
        const savedCardState: CardType[] = this.getCardState();
        this.activeCards.map((c) => {
          if (savedCardState.indexOf(c.type) > -1) {
            this.openCard(c);
          } else {
            c.open = false;
          }
        });
      } else {
        this.openDefaultCards();
      }
    }
  }

  public resetCardsError(): void {
    this.cards.forEach((card: ICard) => {
      card.hasError = false;
    });
  }

  /**
   * check if cafeteria card is active
   */
  private hasCafeteriaCard(): boolean {
    return this.activeCards.filter(c => c.type === CardType.cafeteria).length > 0;
  }

  /**
   * check if has open order in the cafeteria
   */
  private hasOpenCafeteriaOrder(): boolean {
    return false;
  }

  /**
   * check if has state saved in the local storage
   */
  private hasSavedCardsState(): boolean {
    const state: CardType[] = this.getCardState();
    return state.length > 0;
  }

  /**
   * get cards state from the local storage and return as array of CardType
   */
  private getCardState(): CardType[] {
    const stateStr = localStorage.getItem(this.cardsStateKey);
    if (stateStr) {
      try {
        const tmpArr = JSON.parse(stateStr);
        return tmpArr.filter((str) => {
          return this.activeCards.filter(c => c.type === str).length > 0;
        }).slice(0, 2);
      } catch (e) {
        return [];
      }
    }
    return [];
  }

  /**
   * save card state in local storage
   */
  private saveCardsState(newState: string[] = null): void {
    let state;
    if (!newState) {
      state = JSON.stringify(this.openCards.map(c => c.type));
    } else {
      state = JSON.stringify(newState);
    }
    localStorage.setItem(this.cardsStateKey, state);
  }

  /**
   * close all large cards
   */
  private closeAllLargeCards(): void {
    this.openCards.map((c) => {
      if (c.large) {
        c.open = false;
      }
    });
  }

  /**
   * close all cards
   */
  private closeAllCards(): void {
    this.openCards.map((c) => {
      c.open = false;
    });
  }

  /**
   * open base default cards
   */
  private openDefaultCards(): void {
    this.activeCards.map((c: ICard) => {
      if (c.type === CardType.meetings || c.type === CardType.timezone) {
        this.openCard(c);
      }
    });
  }

  /**
   * open cafeteria cards and close all others
   */
  private openCafeteriaCard(): void {
    this.activeCards.map((c) => {
      c.open = c.type === CardType.cafeteria;
      return c;
    });
  }

  /**
   * open a card
   * @param card - home card
   */
  private openCard(card: ICard): void {
    card.open = true;
  }

  private removeInactiveOpenCards(): void {
    const newState = [];
    this.getCardState().forEach((cardType: CardType) => {
      if (this.activeCards.filter(c => c.type === cardType).length) {
        newState.push(cardType);
      } else {
        this.available.find(c => c.type === cardType).open = false;
      }
    });
    this.available.map((c: ICard) => {
      if (newState.indexOf(c.type) === -1) {
        c.open = false;
      }
      return c;
    });
    this.saveCardsState(newState);
  }
}

export interface ICard {
  type: CardType;
  title: string;
  open: boolean;
  active: boolean;
  available: boolean;
  large: boolean;
  icon?: string;
  iconMore?: string;
  bgColor: string;
  loaderOpacity: number;
  loading: boolean;
  mustActive?: boolean;
  fadeIn?: boolean;
  fadeOut?: boolean;
  waitForAnimation?: boolean;
  path: string;
  hasError?: boolean;
  refreshDuration?: number;
  headerGif?: string;
  openByDefault?: boolean;
}


export enum CardType {
  meetings = 'next_meeting',
  flexibleSeating = 'flexible_seating',
  learning = 'learning',
  timezone = 'timezone',
  parking = 'parking_spots',
  transportation = 'transportation',
  card5 = 'card5',
  cafeteria = 'cafeteria',
  card8 = 'card8',
  jobs = 'internal_mobility',
  card10 = 'card10',
  travel = 'travel_expence',
  myBenefits = 'my_expence',
  myRequests = 'my_requests',
  travelReceipt = 'travel_receipt',
  carServices = 'car_services'
}
